import { breakpoints } from 'styles/mq'
import { Section } from 'components/section'
import ContactInfo from 'components/contact-info'
import HeroSrc from './images/hero.webp'
import HeroMobileSrc from './images/hero-mobile.webp'
import { HeroImage, SectionWrapper } from './styled'

export const Longread = () => (
  <div>
    <picture>
      <source srcSet={HeroMobileSrc} media={breakpoints.smallOnly} />
      <HeroImage src={HeroSrc} />
    </picture>

    <SectionWrapper>
      <Section
        heading="Как решить проблему насилия в отношении женщин в Центральной Азии? "
        containerType="text"
      >
        <p>
          Гендерная исследовательница Фарангис Давронова считает, что домашнее
          насилие не может быть оправдано традицией, культурой или религией. По
          ее мнению, признание — это только начало, а реальные изменения
          наступят, когда общество перестанет замалчивать проблему и
          перекладывать вину на переживших насилие.
        </p>
        <p>
          "Насилие – это не семейное дело и не часть культуры. Это преступление,
          за которое виновные должны нести ответственность. Голоса женщин должны
          быть услышаны, а их безопасность – гарантирована государством", –
          отмечает Фарангис.
        </p>
        <p>
          Она подчеркивает, что для защиты женщин необходимы системные меры:
          криминализация домашнего насилия, создание доступных шелтеров,
          юридической и психологической помощи, работа над религиозным
          просвещением населения о правах женщин, а также работа над разрушением
          гендерных стереотипов. Только так можно создать общество, где насилие
          не имеет оправданий, а права женщин действительно защищены.
        </p>
        <p>
          Аида Альжанова, экспертка по вопросам гендерного равенства, тоже
          говорит о важности комплексного подхода в решении проблемы.
        </p>
        <p>
          "Важна поддержка НКО, которые часто оказываются первыми, кто помогает
          пострадавшим. Общество играет не менее важную роль, меняя восприятие
          проблемы и разрушая стереотипы. Люди должны активно поддерживать
          переживших насилие и создавать атмосферу нетерпимости к агрессии", –
          говорит она.
        </p>
        <p>
          Альжанова считает, что для борьбы с насилием нужно развивать кризисные
          центры, горячие линии, убежища и мобильные службы в отдаленных
          районах. По ее словам, эти структуры должны быть доступными и быстро
          реагировать. Она отмечает важность информационных кампаний, которые
          объясняют, что насилие — недопустимо, и рассказывают, куда можно
          обратиться за помощью.
        </p>
        <p>
          Также она подчеркивает, что для разработки более точных и эффективных
          мер, нужен постоянный сбор и анализ данных о насилии.
        </p>
        <p>
          Аида Альжанова объясняет, что важную роль играет экономическая
          независимость женщин. Программы по обучению финансовой грамотности и
          созданию рабочих мест помогают выйти из зависимости от агрессора.
          Кроме того, важно вовлекать женщин в политику, поддерживать активисток
          и ролевые модели, готовить специалистов для работы с пострадавшими и
          бороться с языком ненависти и дискриминацией.
        </p>
      </Section>
      <ContactInfo />
    </SectionWrapper>
  </div>
)
